import React, { useEffect, useState, useMemo } from 'react';
import { ExcelStyle } from 'ag-grid-community';

const useExcelStyles = (): { commonExcelStyles: ExcelStyle[] } => {
  // @ts-ignore https://www.ag-grid.com/react-data-grid/excel-export-styles/
  const commonExcelStyles = useMemo<ExcelStyle[]>(() => {
    return [
      {
        id: 'header',
        font: {
          fontName: 'MeiryoUI',
          size: 9,
          // color: '#0000ff',
        },
      },
      {
        id: 'cell',
        font: {
          fontName: 'MeiryoUI',
          size: 9,
          // color: '#ff0000',
        },
      },
    ];
  }, []);

  return { commonExcelStyles };
};

export default useExcelStyles;
